import React, { Component, Fragment } from 'react'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'

import withTranslations from 'containers/withTranslations'

class LocalizedString extends Component {
  getString() {
    const { translations, string, group } = this.props

    // Default to the key if translations are not loaded
    if (!translations) {
      return string
    }

    // If group is set use it
    if (group) {
      return translations[group] && translations[group][string] ? translations[group][string] : `${group} - ${string}`
    }

    // Else translate string
    return translations[string] || string
  }

  render() {
    return (
      <Fragment>{this.getString()}</Fragment>
    );
  }
}

export default compose(
  withRouter,
  withTranslations()
)(LocalizedString);


// WEBPACK FOOTER //
// ./src/ui/components/generic/LocalizedString.js